module.exports = "<div align=center id=title-bar ng-if=tbc.settings.showTitle>{{tbc.settings.title}}</div> ";